import { type ComponentType } from 'react';
import type { ModuleId } from '@mentimeter/http-clients';
import { BigPresentation } from './slide-types/big/BigPresentation';
import { BulletsPresentation } from './slide-types/bullets/BulletsPresentation';
import { ChoicesPresentationDataHandler } from './slide-types/choices/ChoicesPresentationDataHandler';
import { DeprecatedPresentation } from './slide-types/deprecated/DeprecatedPresentation';
import { DocumentPresentation } from './slide-types/document/DocumentPresentation';
import { GoogleSlidesPresentation } from './slide-types/google-slides/GoogleSlidesPresentation';
import { HeadingPresentation } from './slide-types/heading/HeadingPresentation';
import { ImagePresentationDataHandler } from './slide-types/image/ImagePresentationDataHandler';
import { InstructionsPresentation } from './slide-types/instructions/InstructionsPresentation';
import { MetadataPresentation } from './slide-types/metadata/MetadataPresentation';
import { MiroPresentation } from './slide-types/miro/MiroPresentation';
import { NumberPresentation } from './slide-types/number/NumberPresentation';
import { NumericalQuestionPresentationDataHandler } from './slide-types/numerical-question/NumericalQuestionPresentationDataHandler';
import { OpenPresentationDataHandler } from './slide-types/open/OpenPresentationDataHandler';
import { ParagraphPresentation } from './slide-types/paragraph/ParagraphPresentation';
import { PinOnImagePresentationDataHandler } from './slide-types/pin-on-image/PinOnImagePresentationDataHandler';
import { PowerpointPresentation } from './slide-types/powerpoint/PowerpointPresentation';
import { QfaPresentation } from './slide-types/qfa/QfaPresentation';
import { QuizChoicesPresentationDataHandler } from './slide-types/quiz-choices/QuizChoicesPresentationDataHandler';
import { QuizLeaderboardPresentationDataHandler } from './slide-types/quiz-leaderboard/QuizLeaderboardPresentationDataHandler';
import { QuotePresentation } from './slide-types/quote/QuotePresentation';
import { RatingGridPresentationDataHandler } from './slide-types/rating-grid/RatingGridPresentationDataHandler';
import { VideoPresentationDataHandler } from './slide-types/video/VideoPresentationDataHandler';
import { QuizOpenPresentationDataHandler } from './slide-types/quiz-open/QuizOpenPresentationDataHandler';
import { HundredPointsPresentationDataHandler } from './slide-types/hundred-points/HundredPointsPresentationDataHandler';
import { FreeTextPresentationDataHandler } from './slide-types/free-text/FreeTextPresentationDataHandler';
import { WordCloudPresentationDataHandler } from './slide-types/wordcloud/WordCloudPresentationDataHandler';
import { ScalesPresentationDataHandler } from './slide-types/scales/ScalesPresentationDataHandler';
import { RankingPresentationDataHandler } from './slide-types/ranking/RankingPresentationDataHandler';

const MODULE_IMPORT_MAP = {
  '100-points': HundredPointsPresentationDataHandler,
  big: BigPresentation,
  bullets: BulletsPresentation,
  choices: ChoicesPresentationDataHandler,
  deprecated: DeprecatedPresentation,
  document: DocumentPresentation,
  'free-text': FreeTextPresentationDataHandler,
  'google-slides': GoogleSlidesPresentation,
  heading: HeadingPresentation,
  image: ImagePresentationDataHandler,
  instructions: InstructionsPresentation,
  metadata: MetadataPresentation,
  miro: MiroPresentation,
  number: NumberPresentation,
  'numerical-question': NumericalQuestionPresentationDataHandler,
  open: OpenPresentationDataHandler,
  paragraph: ParagraphPresentation,
  'pin-on-image': PinOnImagePresentationDataHandler,
  powerpoint: PowerpointPresentation,
  qfa: QfaPresentation,
  'quiz-choices': QuizChoicesPresentationDataHandler,
  'quiz-leaderboard': QuizLeaderboardPresentationDataHandler,
  'quiz-open': QuizOpenPresentationDataHandler,
  quote: QuotePresentation,
  ranking: RankingPresentationDataHandler,
  rating: RatingGridPresentationDataHandler,
  scales: ScalesPresentationDataHandler,
  video: VideoPresentationDataHandler,
  wordcloud: WordCloudPresentationDataHandler,
} satisfies Record<ModuleId, ComponentType>;

export const getPresentationModuleById = (
  moduleId: ModuleId,
): ComponentType => {
  return MODULE_IMPORT_MAP[moduleId] ?? DeprecatedPresentation;
};
